import(/* webpackMode: "eager", webpackExports: ["SharedAuditClient"] */ "/vercel/path0/web/app/s/[token]/shared-audit-client.tsx");
